export const DRAG_X_OFFSET = -10;
export const DRAG_Y_OFFSET = 5;
export const TIME_INTERVAL_FOLDER_EXPAND = 500; // Time in ms to wait before expanding a folder when hovering over it during a drag to a folder
export const DRAG_MOVE_INTO_FOLDER_THRESHOLD = 1000; // Time in ms to wait before moving into a folder when hovering over it during a drag to move folder position
